var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Jipink © "+_vm._s((new Date().getFullYear()))+" "),_c('a',{attrs:{"href":"https://jipink.com","title":"Jipink"}},[_vm._v("Jipink")]),_vm._v(". All Rights Reserved. ")])}
var staticRenderFns = []

export { render, staticRenderFns }